import React from 'react'

import { useRemoteStrings } from '@acorns/web-utils'

import { useBlueprintBindings } from '../utils/blueprint-bindings-context'
import type { GroveBlueprintComponentProps } from '../utils/grove-blueprint-component-props'
import { resolveModifiers } from '../utils/resolve-modifiers'
import { resolveTextValue } from '../utils/resolve-text-value'

export function GroveBlueprintText({ node }: GroveBlueprintComponentProps) {
  const { getRemoteString } = useRemoteStrings()
  const { bindingValues } = useBlueprintBindings()

  /* v8 ignore if -- @preserve */
  if (node.type !== 'Text') {
    return null
  }

  const { className, style, attributes } = resolveModifiers(
    node.modifiers,
    bindingValues,
    (key: string) => getRemoteString({ key }),
  )

  const text = resolveTextValue(
    node.props.text,
    (key: string) => getRemoteString({ key }),
    bindingValues,
  )

  return (
    <span className={className || undefined} style={style} {...attributes}>
      {text}
    </span>
  )
}
